import { FC, PropsWithChildren, memo } from 'react'

import * as SC from './styles'

export const TableFilterRow: FC<PropsWithChildren> = memo(({ children }) => {
  return <SC.Box>{children}</SC.Box>
})
